/**
 * @Author: qinyifang
 * @Date: 2025-04-28 14:46:30
 * @Description: API接口路径常量定义，包括登录、对话等相关的接口地址
 */
export const BASE_PREFIX = "https://ux-assest.jlpay.com/uni-app/" // cdn 资源
export const BASE_IMAGE_PREFIX = BASE_PREFIX + "images/" // cdn 公共图片

// API路径定义
// 登录相关
export const wecomLoginApi = "login/auth" // 企业微信登录接口（与账密登录共用）
export const getwecomConfigApi = "login/config" // 获取企业微信的appid和agentid
export const loginoutApi = "login/logout" // 退出登录
export const openLoginApi = "login/open/auth" // 开放平台登录
export const tokenQueryApi = "ai-assistant/token/query" // 通过 token_id 查询 token

// 对话相关
export const conversationsApi = "conversations/list" // 历史会话
export const messagesApi = "conversations/history/messages" // 聊天消息列表
export const chatMessagesApi = "conversations/send/messages" // 发送聊天消息
export const conversationNameApi = "conversations/update/title" // 对话名称
export const conversationDeleteApi = "conversations/delete" // 删除对话
export const messageFeedbackApi = "messages/feedback" // 消息反馈
export const messageUpdateStatusApi = "messages/update-status" // 更新消息状态
export const feedbackTagsApi = "v1/feedback-tags/list" // 点赞点踩标签查询
export const fileUploadApi = "file/upload" // 文件上传
export const fileDeleteApi = "file/delete" // 文件删除

// 智能体相关
export const userAgentInfoApi = "user-agent/info" // 智能体列表
export const agentFaqApi = "v1/agent-faq/list" // 智能体高频问题列表
export const agentFaqInputOptionsApi = "v1/agent-faq/input-options" // 智能体高频问题参数配置

// 文件处理相关
export const fileHandleQueryApi = "file/handle/query" // 文件处理结果查询

// 语音识别相关
export const asrAuthApi = "asr/auth" // 获取语音识别鉴权信息

// 图表相关
export const chartDataQueryApi = "chart/data/v1" // 图表数据查询

// 智齿客服相关
export const sobotTransferToHumanApi = "sobot/transfer-to-human" // 请求人工客服
export const sobotSendMessageApi = "sobot/send/messages" // 发送消息到智齿客服
export const sobotGetMessagesApi = "sobot/messages" // 查询客服消息
export const sobotEndSessionApi = "sobot/end-session" // 客户结束会话

// 投诉工单相关
export const workOrderCreateApi = "external-gateway/manage-ai-config/manage/ai/work-order/create" // 创建投诉工单

// 服务小结相关（智齿人工坐席）
export const serviceSummarySaveOrUpdateApi = "manage-gateway/manage-ai-config/manage/ai/service-summary/save_or_update" // 服务小结-保存或更新
export const serviceSummaryCategoryListApi = "manage-gateway/manage-ai-config/manage/ai/service-summary/category/list" // 服务小结-分类树查询

// 工单类型级联（智齿人工坐席，接口同工单 createOrder）
// typeKey: 01-工单产品类型 02-工单大类 03-工单小类，parentTypeId 为上级 typeId
export const workOrderTypeListApi = "manage-gateway/work-order/findWorkTypeList"
